module.exports = __webpack_public_path__ + "img/emiles_zebre.eedb78da.png";